export const geminiMandatoryOptions = [
    {
        key: "GeminiConversations",
        name: "GeminiConversations",
        title: "Gemini Apps conversations",
        description: "All conversations you’ve had in Gemini Apps (the Gemini chatbot).",
        optionPlatform: "gemini",
        essential: true,         
        payment: "+$5.0",
        type: "standard",
        parent: null,
        use: null,
        warning: "These conversations may contain sensitive personal information. We strongly recommend checking the archive before donation."
    },

]; 


export const geminiOptionalOptions  = [ 
    /*
    {
        key: "GoogleSearchActivity",
        name: "GoogleSearchActivity",
        title: "Search activity related to Google",
        description: "Search queries from Google Search that are linked to Google (for example when Google answers inside Search).",
        optionPlatform: "gemini",
        essential: false,        
        payment: "+£0.5",          // or whatever bonus 
        type: "standard",
        parent: null,
        use: "Helps us understand how people arrive at Gemini via Google Search and what they search for before or after using Gemini.",
        warning: null
    },
    {
        key: "GoogleAIMode",
        name: "GoogleAIMode",
        title: "AI mode / AI Overviews",
        description: "Records of Google ‘AI mode’ or AI Overviews in Search, where Google generates answers instead of showing only links.",
        optionPlatform: "gemini",
        essential: false,        
        payment: "+£0.5",          
        type: "standard",
        parent: null,
        use: "Lets us study how often people use AI answers in Search and which topics appear in AI mode.",
        warning: null
    },
*/ 
    {
        key: "GeminiUploadedFiles",
        name: "GeminiUploadedFiles",
        title: "Files uploaded to Gemini Apps",
        description: "Files you have uploaded (or generated) to Gemini Apps (the Gemini chatbot) during your conversations such as images or documents.",
        optionPlatform: "gemini",
        essential: false,        
        payment: "+$2.0",          
        type: "standard",
        parent: null,
        use: null,
        warning: "Uploaded files may contain sensitive personal information. We strongly recommend checking the archive before donation."
    },

]; 



export const geminiExcludedOptions  = [



]; 